import { render } from "./new-remark-modal.vue?vue&type=template&id=b4f3e2f9"
import script from "./new-remark-modal.vue?vue&type=script&lang=js"
export * from "./new-remark-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__